import { Card } from '@payaca/ambrosia';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC, PropsWithChildren } from 'react';

const InvoiceCard_: FC<PropsWithChildren<{ borderless?: boolean }>> = ({
  children,
  borderless,
}) => {
  return (
    <Card className={clstx(borderless && 'border-0 shadow-none')}>
      <Card.Body className="space-y-4">{children}</Card.Body>
    </Card>
  );
};

const Grid: FC<PropsWithChildren> = ({ children }) => {
  return <div className="grid grid-cols-3 grid-rows-2 gap-4">{children}</div>;
};

const GridElement: FC<PropsWithChildren & { title?: string }> = ({
  children,
  title,
}) => {
  return (
    <div>
      {title && <p className="supporting-body text-gray-500">{title}</p>}
      {children}
    </div>
  );
};

const Actions: FC<PropsWithChildren> = ({ children }) => {
  return <div className="flex flex-row gap-4 flex-wrap">{children}</div>;
};

const PrimaryAction: FC<PropsWithChildren> = ({ children }) => {
  return <div className="flex-shrink ml-auto">{children}</div>;
};

const Secondary: FC<PropsWithChildren> = ({ children }) => {
  return <div className="flex flex-row flex-grow">{children}</div>;
};

const SecondaryAction: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="border-r border-gray-200 last:border-r-0 px-4 first:pl-0">
      {children}
    </div>
  );
};

export const InvoiceCard = Object.assign(InvoiceCard_, {
  Grid: Object.assign(Grid, {
    Element: GridElement,
  }),
  Actions: Object.assign(Actions, {
    PrimaryAction,
    Secondary: Object.assign(Secondary, {
      Action: SecondaryAction,
    }),
  }),
});
